define('commons/custom-variables-parser',['jquery', 'commons/variables-regex-provider'], function($, regexProvider) {

    var allowedTypes = ['bool', 'int', 'uint', 'float', 'char'];
    var mockValues = ['true', '-1', '1', '1.2', 'example'];

    var CustomVariablesParser = function() {};

    CustomVariablesParser.prototype.parse = function(customPayloadConfig) {
        var elements = [];

        // Allow empty customPayloadCOnfig
        if (!customPayloadConfig || customPayloadConfig.trim().length === 0) {
            return {
                success: true,
                elements: elements
            };
        }

        var firstSplit = customPayloadConfig.split(/ +/);
        var length = firstSplit.length;

        var currentToken;
        var splittedToken;
        var name;
        var nameRegex = regexProvider.getCustomVarNameRegex();
        for (var i = 0; i < length; i++) {
            currentToken = firstSplit[i];
            splittedToken = currentToken.split(/[:]/);

            // At least 4 parts (name, begin index, type, length)
            if (splittedToken.length < 4) {
                return {
                    success: false,
                    error: "Invalid token : " + currentToken
                };
            }

            name = splittedToken[0];
            if(name.match(nameRegex) == null){
                return {
                    success: false,
                    error: "Invalid variable name : " + name
                };
            }

            // type is restricted
            var type = splittedToken[2];
            var typeIdx = $.inArray(type, allowedTypes);
            if (typeIdx < 0) {
                return {
                    success: false,
                    error: "Unknown type " + type
                };
            }

            elements.push({
            	name: 'customData#' + splittedToken[0],
            	mockValue: mockValues[typeIdx]
            });
        }

        return {
            success: true,
            elements: elements
        };
    };

    return new CustomVariablesParser();
});
